// BreakSheetHost — owns the break actions for ONE room.
//
// `useRoomBreakActions` is a hook keyed to a room, so it cannot be called from
// inside a card list. Mounting this only while a break sheet is open keeps the
// hook count stable and scopes the actions to the room actually being acted on.

import React, { useState } from "react";
import useRoomBreakActions from "../../hooks/useRoomBreakActions";
import PanelBreakSheet from "./PanelBreakSheet";

export default function BreakSheetHost({
  room,
  assignment,
  providerName,
  lane,
  breakRow,
  candidates,
  onDone,
  onError,
}) {
  const { assignBreak } = useRoomBreakActions({ room, assignment, providerName });
  const [busy, setBusy] = useState(false);

  return (
    <PanelBreakSheet
      lane={lane}
      breakRow={breakRow}
      candidates={candidates}
      busy={busy}
      onClose={onDone}
      onCommit={async ({ channel, giver }) => {
        setBusy(true);
        try {
          // An EXPLICIT giver. Without it assignBreak falls back to the
          // signed-in user, which on a shared workstation or a wall device
          // records the device as the person who gave the break.
          const ok = await assignBreak({ channel, giver });
          if (ok === false) {
            onError("That break could not be given. It may already be done.");
            return;
          }
          onDone();
        } catch (e) {
          onError(e?.message || "That break could not be given.");
        } finally {
          setBusy(false);
        }
      }}
    />
  );
}
